import { ADDCUSTOMER_FAIL, ADDCUSTOMER_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const addCustomerReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADDCUSTOMER_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case ADDCUSTOMER_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default addCustomerReducer;
